import breakpoints from '../constants/break-points';

type BreakPoints = {
  isSmall: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isXl: boolean;
};

const BREAKPOINTS_FLAG = {
  isSmall: true,
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isXl: false
};

const getFlagsObject = (currentBreakpoint: string) => ({
  ...BREAKPOINTS_FLAG,
  [currentBreakpoint]: true
});

const getBreakpointFlags = (width: number): BreakPoints => {
  if (width < breakpoints.sm) {
    return getFlagsObject('isSmall');
  }
  if (width < breakpoints.md) {
    return getFlagsObject('isMobile');
  }
  if (width < breakpoints.lg) {
    return getFlagsObject('isTablet');
  }
  if (width < breakpoints.xl) {
    return getFlagsObject('isDesktop');
  }
  return getFlagsObject('isXl');
};

export default getBreakpointFlags;
